module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/超狭額薄型ノートパソコンカメラ.08772064.png";